import { authHeader } from "@roman/shared/lib/auth/authHeader";
import romanApi, { type RomanApiError } from "@roman/shared/lib/net/romanApi";
import type { Key } from "swr";
import useSWRMutation from "swr/mutation";

interface WithdrawalArg {
  destUserAddress: string;
  nanoTon: string;
  userId: string;
}

interface WithdrawalSuccessResponse extends WithdrawalArg {
  message: string;
}

const postWithdrawalRequest = async (url: string, { arg }: { arg: WithdrawalArg }) => {
  const headers = authHeader.getOrThrow();
  return romanApi.post<WithdrawalSuccessResponse, WithdrawalArg>(url, arg, { headers });
};

export const usePostWithdrawalRequest = () => {
  const { data, isMutating, trigger, error } = useSWRMutation<
    WithdrawalSuccessResponse,
    RomanApiError,
    Key,
    WithdrawalArg
  >("/payment/withdrawal", postWithdrawalRequest);

  return {
    data,
    trigger,
    isMutating,
    isError: error !== undefined,
    error,
  };
};
